"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loading = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactFela = require("react-fela");

var _ = require("../..");

var css = _interopRequireWildcard(require("./Loading.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Loading indicators are a visual indicator for an unspecified wait time,
 * usually to communicate that the application is currently loading.
 *
 * The root element is a `View` component, and all unhandled props are spread
 * to the root element.
 */
const Loading = ({
  color,
  ...props
}) => {
  const {
    renderer
  } = (0, _reactFela.useFela)();
  const animation = renderer.renderKeyframe(css.bounce, {});
  const cssProps = {
    animation,
    coinColor: color
  };
  return (0, _pragma.createFelaElement)(_.View, _extends({
    "aria-label": "Loading",
    gap: "small"
  }, props), (0, _pragma.createFelaElement)("span", {
    css: css.coin,
    cssProps: { ...cssProps,
      index: 0
    }
  }), (0, _pragma.createFelaElement)("span", {
    css: css.coin,
    cssProps: { ...cssProps,
      index: 1
    }
  }), (0, _pragma.createFelaElement)("span", {
    css: css.coin,
    cssProps: { ...cssProps,
      index: 2
    }
  }), (0, _pragma.createFelaElement)("span", {
    css: css.coin,
    cssProps: { ...cssProps,
      index: 3
    }
  }), (0, _pragma.createFelaElement)("span", {
    css: css.coin,
    cssProps: { ...cssProps,
      index: 4
    }
  }));
};

exports.Loading = Loading;
Loading.displayName = 'Loading';
var _default = Loading;
exports.default = _default;
//# sourceMappingURL=Loading.js.map